<template>
  <div>
    <!-- <div
      style="font-size: 12px; font-weight: 700"
      class="text-right pt-3 pr-5 mb-3"
    >
      Displaying {{ documents.length }} items.
    </div> -->
    <h2 v-if="heading">{{ heading }}</h2>
    <v-data-table
      :hide-default-footer="hideFooter"
      :headers="headers"
      :items="documents"
      :items-per-page="itemsPerPage"
      class="elevation-1 hover my-8"
      show-expand
      item-key="title"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      @click:row="clicked"
      :search="search"
      dense
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :footer-props="{
        itemsPerPageText: 'Number of documents per page:',
        itemsPerPageOptions: [15, 25, 50, 100, -1],
      }"
      v-if="
        $vuetify.breakpoint.md ||
        $vuetify.breakpoint.lg ||
        $vuetify.breakpoint.xl
      "
    >
      <template v-slot:top v-if="!hideSearch">
        <div class="pt-5">
          <v-text-field
            v-model="search"
            :label="searchLabel"
            class="mx-4"
          ></v-text-field>
        </div>
      </template>
      <template v-slot:item.title="{ item }">
        <div class="my-2">
          <span class=""
            ><strong>{{ item.title }}</strong></span
          >
        </div>
      </template>
      <template v-slot:item.updated_at="{ item }">
        <div>
          {{ item.updated_at | dateFormat }}
        </div>
      </template>
      <template v-slot:item.published_at="{ item }">
        <div>
          <div>
            <v-chip
              :dark="getNewOrUpdatedLabel(item) === 'Updated!' ? false : true"
              :outlined="
                getNewOrUpdatedLabel(item) === 'Updated!' ? true : false
              "
              small
              color="#1b6fb5"
              v-if="isItNew(item)"
              class="text-center"
              :class="{ darkText: getNewOrUpdatedLabel(item) === 'Updated!' }"
              v-html="getNewOrUpdatedLabel(item)"
            >
            </v-chip>
          </div>
        </div>
      </template>
      <template v-slot:item.unit.shortname="{ item }">
        <div
          style="color: #000; font-weight: bold"
          v-if="item.unit && item.unit.shortname"
        >
          {{ item.unit.shortname }}
        </div>
        <div v-else style="color: #000; font-weight: bold">General</div>
      </template>
      <template v-slot:item.file.ext="{ item }">
        <span v-if="item.file && item.file.ext">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                color="grey lighten-4"
                size="55"
                class="my-1"
                @click.stop.prevent="download(item.file)"
                v-if="item.file"
                v-bind="attrs"
                v-on="on"
              >
                <span
                  style="
                    font-weight: 900;
                    font-size: 14px;
                    text-transform: uppercase;
                  "
                  >{{ item.file.ext.substring(1) }}
                </span>
              </v-avatar>
            </template>
            <span v-if="item && item.file">{{ item.file.name }}</span>
          </v-tooltip>
        </span>
        <span v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                color="white"
                size="35"
                class="my-1"
                v-bind="attrs"
                v-on="on"
                @click.stop.prevent="goToExternal(item.externalURL)"
              >
                <span
                  style="
                    font-weight: 400;
                    font-size: 10px;
                    text-transform: uppercase;
                  "
                  ><v-icon small v-bind="attrs" v-on="on">open_in_new</v-icon>
                </span>
              </v-avatar>
            </template>
            <span v-if="item.externalURL">{{ item.externalURL }}</span>
          </v-tooltip>
        </span>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td
          :colspan="headers.length"
          style="padding: 0 !important; margin: 0 !important"
        >
          <DocumentCard :item="item" class=""></DocumentCard>
        </td>
      </template>
    </v-data-table>
    <div v-else>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th class="text-left">Date</th>
              <th class="text-left">Title</th>

              <th class="text-left">Download/Link</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in documents"
              :key="`mobile-table-${index}`"
              @click.stop.prevent="goToLink(item)"
              class="hover"
            >
              <td>
                <v-chip
                  :dark="
                    getNewOrUpdatedLabel(item) === 'Updated!' ? false : true
                  "
                  :outlined="
                    getNewOrUpdatedLabel(item) === 'Updated!' ? true : false
                  "
                  small
                  color="#1b6fb5"
                  v-if="isItNew(item)"
                  class="text-center"
                  :class="{
                    darkText: getNewOrUpdatedLabel(item) === 'Updated!',
                  }"
                  v-html="getNewOrUpdatedLabel(item)"
                >
                </v-chip>
              </td>
              <td>
                {{ item.updated_at | dateFormatShort }}
              </td>
              <td>
                <strong>{{ item.title }}</strong>
              </td>
              <td class="text-center">
                <span v-if="item.externalURL">
                  <v-icon small>open_in_new</v-icon>
                </span>
                <span v-else>
                  <v-avatar color="grey lighten-2" size="35" class="my-3">
                    <span
                      style="
                        font-weight: 900;
                        font-size: 10px;
                        text-transform: uppercase;
                      "
                      >{{ item.file.ext.substring(1) }}
                    </span>
                  </v-avatar>
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { handleClicks } from "@/mixins/handleClicks";
import { renderToHtml } from "@/services/Markdown";

import dayjs from "dayjs";
// eslint-disable-next-line no-unused-vars
import { fixBlankTableHeadings, fixButtonText } from "@/a11y";
export default {
  mixins: [handleClicks],
  data() {
    return {
      sortBy: "updated_at",
      sortDesc: true,
      items_per_page: [100, 200, 300 - 1],
      error: null,
      expanded: [],
      search: "",
      singleExpand: true,
      loading: true,
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "updated_at",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "published_at",
        },
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
        },
        {
          text: "Unit",
          align: "start",
          sortable: true,
          value: "unit.shortname",
        },

        {
          text: "Download/Link",
          align: "center",
          sortable: true,
          value: "file.ext",
        },
      ],
    };
  },

  created() {},
  async mounted() {
    await this.$nextTick();
    this.a11yfixes();
  },
  methods: {
    a11yfixes() {
      fixButtonText(
        "v-data-table__expand-icon",
        "Click to show or hide document information"
      );
      fixBlankTableHeadings();
    },
    render(content) {
      return renderToHtml(content);
    },
    isItNew(item) {
      let days = dayjs().diff(dayjs(item.updated_at), "day", true);

      if (days <= this.$myApp.config.daysToShowNew) {
        return true;
      } else {
        return false;
      }
    },
    getNewOrUpdatedLabel(item) {
      let days = dayjs(item.updated_at).diff(
        dayjs(item.published_at),
        "day",
        true
      );
      if (days > 1) {
        return "Updated!";
      } else {
        return "&nbsp;&nbsp;&nbsp;&nbsp;New!&nbsp;&nbsp;&nbsp;&nbsp;";
      }
    },
    goToLink(item) {
      if (item.externalURL) {
        this.goToExternal(item.externalURL);
      } else {
        this.download(item.file);
      }
    },
    goToExternal(url) {
      console.log("external_click: ", url);
      //window.plausible("external_click", { props: { url: url } });
      //
      if (url.indexOf("://") > 0 || url.indexOf("//") === 0) {
        window.open(url);
        console.log("absolute: ", url);
      } else {
        this.$router.push(url);
        console.log("relative: ", url);
      }
    },
    download(file) {
      let download = `${this.$myApp.config.api.base}${file.url}`;
      console.log("document_download: ", file.url);
      //window.plausible("document_download", { props: { file: file.url } });
      if (file.ext === ".pdf") {
        window.open(download);
      } else {
        location.href = download;
      }
    },

    clicked(value) {
      //console.log(value);
      if (value === this.expanded[0]) {
        this.expanded = [];
      } else {
        if (this.expanded.length) {
          this.expanded.shift();
          this.expanded.push(value);
        } else {
          this.expanded.push(value);
        }
      }
    },
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    documents: {
      type: Array,
      default: () => {},
    },
    searchLabel: {
      type: String,
      default: "Filter Documents",
    },
    chipLabel: {
      type: String,
      default: "Updated!",
    },
    elevation: {
      type: Number,
      default: 2,
    },
    itemsPerPage: {
      type: Number,
      default: 15,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.darkText {
  font-weight: 700 !important;
}
/* tbody tr:nth-of-type(even) {
  background-color: rgba(250, 250, 250);
} */

/* tbody tr:nth-of-type(odd) {
  background-color: rgb(253, 253, 253);
} */

/* .v-data-table-header {
  background-color: rgba(182, 183, 187);
  color: white !important;
} */

/* .v-data-footer {
  background-color: rgb(250, 250, 250);
}

.theme--light.v-data-table thead tr th {
  color: white;
} */
</style>
